import React from 'react';

export const CopyIcon = () => (
    <svg
        width="15px"
        height="18px"
        viewBox="0 0 15 18"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <path
                d="M10,19 L18,19 L18,8 L10,8 L10,19 Z M8,7.99188419 C8,6.89179693 8.90195036,6 10.0085302,6 L17.9914698,6 C19.1007504,6 20,6.89339733 20,7.99188419 L20,19.0081158 C20,20.1082031 19.0980496,21 17.9914698,21 L10.0085302,21 C8.8992496,21 8,20.1066027 8,19.0081158 L8,7.99188419 Z M5,16 L5,4.99188419 C5,3.89179693 5.90195036,3 7.0085302,3 L14.9914698,3 L15,3 L15,16 L5,16 Z M7,16 L15,16 L15,5 L7,5 L7,16 Z"
                id="path-1-CopyIcon1"
            />
        </defs>
        <g
            id="Page-1"
            stroke="none"
            strokeWidth={1}
            fill="none"
            fillRule="evenodd"
            opacity="0.719999969"
        >
            <g
                id="Data-Studio---VD-V3"
                transform="translate(-1225.000000, -66.000000)"
            >
                <g id="Group-6" transform="translate(1220.000000, 63.000000)">
                    <g id="standard/action/copy">
                        <mask id="mask-2-CopyIcon1" fill="white">
                            <use xlinkHref="#path-1-CopyIcon1" />
                        </mask>
                        <use
                            id="copy"
                            fill="#42526E"
                            fillRule="nonzero"
                            xlinkHref="#path-1-CopyIcon1"
                        />
                        <g
                            id="White-/-B200"
                            mask="url(#mask-2-CopyIcon1)"
                            fill="#E0E1EC"
                            fillRule="evenodd"
                        >
                            <polygon id="B200" points="0 24 24 24 24 0 0 0" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const ClearIcon = () => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <path
                d="M23.2843139,21.8567342 C23.6729538,21.8567342 23.9873906,22.171218 23.9873906,22.5598579 C23.9873906,22.9484977 23.6729069,23.2629815 23.284267,23.2629815 L23.284267,23.2629815 L0.715639227,23.2629815 C0.326999361,23.2629815 0.0125156006,22.9484977 0.0125156006,22.5598579 C0.0125156006,22.171218 0.326999361,21.8567342 0.715639227,21.8567342 L0.715639227,21.8567342 Z M5.96112898,8.82354094 L15.9049377,18.7673496 L14.2216128,20.450487 L2.79576016,20.450487 L1.02740424,18.6823654 C-0.342468081,17.3118369 -0.342468081,15.0809193 1.02740424,13.7103908 L1.02740424,13.7103908 L5.96112898,8.82354094 Z M13.0068027,1.77791407 C14.3766282,0.408041747 16.6075457,0.406682374 17.9787774,1.77791407 L17.9787774,1.77791407 L22.9725958,6.74988874 C24.3424681,8.12041731 24.3424681,10.3513348 22.9725958,11.7218634 L22.9725958,11.7218634 L16.8992014,17.773086 L6.95539267,7.82927725 Z"
                id="path-1-ClearIconi"
            />
        </defs>
        <g
            id="Icons/Console/Clear"
            stroke="none"
            strokeWidth={1}
            fill="none"
            fillRule="evenodd"
        >
            <mask id="mask-2-ClearIconi" fill="white">
                <use xlinkHref="#path-1-ClearIconi" />
            </mask>
            <use
                id="Combined-Shape"
                fill="#000000"
                fillRule="nonzero"
                xlinkHref="#path-1-ClearIconi"
            />
            <g
                id="↳-🎨Color/Neutral/100"
                mask="url(#mask-2-ClearIconi)"
                fill="#D4D6E0"
            >
                <rect id="Color-Container" x={0} y={0} width={24} height={24} />
            </g>
        </g>
    </svg>
);

export const RunIcon = () => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <path
                d="M12,4 C7.58886092,4 4,7.58886092 4,12 C4,16.4111391 7.58886092,20 12,20 C16.4111391,20 20,16.4111391 20,12 C20,7.58886092 16.4111391,4 12,4 Z M10,15.9999151 L10,7.99997171 L16,11.9999151 L10,15.9999151 Z"
                id="path-1-RI1"
            />
        </defs>
        <g
            id="Symbols"
            stroke="none"
            strokeWidth={1}
            fill="none"
            fillRule="evenodd"
        >
            <g id="workflow/action/run/normal">
                <mask id="mask-2-RI1" fill="white">
                    <use xlinkHref="#path-1-RI1" />
                </mask>
                <use id="Shape" fill="#000000" fillRule="nonzero" xlinkHref="#path-1-RI1" />
                <g id="↳-🎨Color/Neutral/100" mask="url(#mask-2-RI1)" fill="#14182A">
                    <g transform="translate(-74.000000, -18.000000)" id="Color-Container">
                        <rect x={0} y={0} width={171} height={60} />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);


export const RepairIcon = () => (
    <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.686 18.843l.47.47A2.316 2.316 0 006.809 20c.625 0 1.212-.244 1.652-.686l4.817-4.814A5.347 5.347 0 0020 9.341a5.29 5.29 0 00-.453-2.145l-.004-.01-.003-.01-.003-.007a.096.096 0 00-.003-.007c-.003-.008-.008-.016-.013-.024a.246.246 0 01-.01-.016l-.003-.005a.556.556 0 00-.034-.06c-.013-.018-.026-.034-.04-.05l-.008-.009-.01-.014a.196.196 0 00-.023-.024l-.004-.004c-.017-.017-.035-.03-.054-.045l-.01-.007-.014-.011-.026-.02c-.017-.011-.035-.02-.053-.029l-.013-.006a.319.319 0 00-.108-.042l-.014-.004a.269.269 0 00-.05-.013c-.024-.005-.048-.006-.073-.008h-.01a.457.457 0 01-.043-.004.501.501 0 00-.068.007h-.008a.612.612 0 01-.019.003c-.012 0-.024.002-.035.004a.372.372 0 00-.058.017l-.006.002c-.022.007-.043.013-.064.022l-.006.001a.054.054 0 00-.005.002l-.024.013-.016.01-.003.002a.557.557 0 00-.115.079l-.004.003-.014.011c-.008.006-.016.012-.023.02l-2.497 2.49-1.416-1.415 2.497-2.491.015-.019.012-.014.003-.004c.017-.019.033-.037.047-.058.01-.015.019-.03.027-.046l.009-.015a.322.322 0 01.01-.017l.014-.026.002-.006.002-.005.021-.063.002-.008a.593.593 0 01.006-.018l.011-.039c.003-.013.004-.026.005-.04l.002-.02.002-.017a.473.473 0 00.005-.052c0-.013-.001-.026-.003-.038l-.001-.017-.001-.014c-.002-.02-.003-.039-.006-.058a.37.37 0 00-.011-.04l-.006-.019-.005-.018c-.004-.015-.008-.03-.014-.045-.005-.013-.011-.026-.018-.038l-.009-.016-.005-.012c-.009-.017-.017-.034-.027-.05-.006-.01-.013-.018-.02-.027a.681.681 0 01-.012-.015l-.004-.006a.573.573 0 00-.047-.057l-.003-.003-.004-.004a.17.17 0 00-.02-.018.281.281 0 01-.014-.01l-.008-.007a.486.486 0 00-.106-.074l-.007-.004-.017-.01-.027-.015a.116.116 0 00-.007-.003.108.108 0 01-.008-.003l-.017-.006c-.68-.3-1.401-.453-2.146-.453A5.347 5.347 0 009.5 10.722l-4.813 4.816A2.318 2.318 0 004 17.19c0 .626.244 1.212.686 1.652zM15 5c.218 0 .432.023.643.057l-2.04 2.04c-.252.252-.39.587-.39.943s.138.691.39.943l1.414 1.414c.26.26.601.39.943.39.34 0 .683-.13.942-.39l2.04-2.04c.035.211.058.425.058.643 0 2.206-1.938 4.214-4.143 4.214-.457 0-1.342-.23-1.343-.23l-.01-.004a3.992 3.992 0 01-2.647-3.765C10.857 7.009 12.794 5 15 5zm-4.977 7.036c-.008-.012-.017-.023-.024-.036l-4.405 4.444a1.051 1.051 0 00-.312.751c0 .284.11.55.311.75l.5.5a1.078 1.078 0 001.498.001L12 14.004a.465.465 0 01-.037-.025 5.413 5.413 0 01-.415-.281c-.022-.017-.044-.032-.067-.048-.036-.024-.071-.049-.105-.076a5.63 5.63 0 01-.948-.95c-.028-.034-.052-.07-.077-.106a3.22 3.22 0 00-.045-.064 5.563 5.563 0 01-.283-.418z"
            fill="#000"
        />
        <mask
            id="ric"
            maskUnits="userSpaceOnUse"
            x={4}
            y={4}
            width={16}
            height={16}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.686 18.843l.47.47A2.316 2.316 0 006.809 20c.625 0 1.212-.244 1.652-.686l4.817-4.814A5.347 5.347 0 0020 9.341a5.29 5.29 0 00-.453-2.145l-.004-.01-.003-.01-.003-.007a.096.096 0 00-.003-.007c-.003-.008-.008-.016-.013-.024a.246.246 0 01-.01-.016l-.003-.005a.556.556 0 00-.034-.06c-.013-.018-.026-.034-.04-.05l-.008-.009-.01-.014a.196.196 0 00-.023-.024l-.004-.004c-.017-.017-.035-.03-.054-.045l-.01-.007-.014-.011-.026-.02c-.017-.011-.035-.02-.053-.029l-.013-.006a.319.319 0 00-.108-.042l-.014-.004a.269.269 0 00-.05-.013c-.024-.005-.048-.006-.073-.008h-.01a.457.457 0 01-.043-.004.501.501 0 00-.068.007h-.008a.612.612 0 01-.019.003c-.012 0-.024.002-.035.004a.372.372 0 00-.058.017l-.006.002c-.022.007-.043.013-.064.022l-.006.001a.054.054 0 00-.005.002l-.024.013-.016.01-.003.002a.557.557 0 00-.115.079l-.004.003-.014.011c-.008.006-.016.012-.023.02l-2.497 2.49-1.416-1.415 2.497-2.491.015-.019.012-.014.003-.004c.017-.019.033-.037.047-.058.01-.015.019-.03.027-.046l.009-.015a.322.322 0 01.01-.017l.014-.026.002-.006.002-.005.021-.063.002-.008a.593.593 0 01.006-.018l.011-.039c.003-.013.004-.026.005-.04l.002-.02.002-.017a.473.473 0 00.005-.052c0-.013-.001-.026-.003-.038l-.001-.017-.001-.014c-.002-.02-.003-.039-.006-.058a.37.37 0 00-.011-.04l-.006-.019-.005-.018c-.004-.015-.008-.03-.014-.045-.005-.013-.011-.026-.018-.038l-.009-.016-.005-.012c-.009-.017-.017-.034-.027-.05-.006-.01-.013-.018-.02-.027a.681.681 0 01-.012-.015l-.004-.006a.573.573 0 00-.047-.057l-.003-.003-.004-.004a.17.17 0 00-.02-.018.281.281 0 01-.014-.01l-.008-.007a.486.486 0 00-.106-.074l-.007-.004-.017-.01-.027-.015a.116.116 0 00-.007-.003.108.108 0 01-.008-.003l-.017-.006c-.68-.3-1.401-.453-2.146-.453A5.347 5.347 0 009.5 10.722l-4.813 4.816A2.318 2.318 0 004 17.19c0 .626.244 1.212.686 1.652zM15 5c.218 0 .432.023.643.057l-2.04 2.04c-.252.252-.39.587-.39.943s.138.691.39.943l1.414 1.414c.26.26.601.39.943.39.34 0 .683-.13.942-.39l2.04-2.04c.035.211.058.425.058.643 0 2.206-1.938 4.214-4.143 4.214-.457 0-1.342-.23-1.343-.23l-.01-.004a3.992 3.992 0 01-2.647-3.765C10.857 7.009 12.794 5 15 5zm-4.977 7.036c-.008-.012-.017-.023-.024-.036l-4.405 4.444a1.051 1.051 0 00-.312.751c0 .284.11.55.311.75l.5.5a1.078 1.078 0 001.498.001L12 14.004a.465.465 0 01-.037-.025 5.413 5.413 0 01-.415-.281c-.022-.017-.044-.032-.067-.048-.036-.024-.071-.049-.105-.076a5.63 5.63 0 01-.948-.95c-.028-.034-.052-.07-.077-.106a3.22 3.22 0 00-.045-.064 5.563 5.563 0 01-.283-.418z"
                fill="#fff"
            />
        </mask>
        <g mask="url(#ric)">
            <path fill="#2A2C42" d="M0 0H24V24H0z" />
        </g>
    </svg>
);

export const ScheduleIcon = () => {

    return (
        <svg
            width={20}
            height={20}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.184 9.258H4.814V6.296c0-.409.332-.741.74-.741h.741v.74c0 .408.333.741.74.741.408 0 .741-.333.741-.74v-.741h4.445v.74c0 .408.333.741.74.741.408 0 .741-.333.741-.74v-.741h.741c.408 0 .74.332.74.74v2.963zm-2.222 4.445H9.999a.743.743 0 01-.741-.74c0-.408.333-.742.74-.742h2.964c.407 0 .74.334.74.741 0 .408-.333.74-.74.74zm-5.926 0a.743.743 0 01-.741-.74c0-.408.333-.742.74-.742.408 0 .741.334.741.741 0 .408-.333.74-.74.74zm7.407-9.63h-.74v-.74a.743.743 0 00-.741-.741.743.743 0 00-.741.74v.741H7.776v-.74a.743.743 0 00-.74-.741.743.743 0 00-.741.74v.741h-.74a2.225 2.225 0 00-2.223 2.222v8.89c0 1.225.997 2.222 2.222 2.222h8.89a2.225 2.225 0 002.221-2.223V6.296a2.225 2.225 0 00-2.222-2.223z"
                fill="#222B45"
            />
            <mask
                id="a-SIC"
                maskUnits="userSpaceOnUse"
                x={3}
                y={2}
                width={14}
                height={16}
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.184 9.258H4.814V6.296c0-.409.332-.741.74-.741h.741v.74c0 .408.333.741.74.741.408 0 .741-.333.741-.74v-.741h4.445v.74c0 .408.333.741.74.741.408 0 .741-.333.741-.74v-.741h.741c.408 0 .74.332.74.74v2.963zm-2.222 4.445H9.999a.743.743 0 01-.741-.74c0-.408.333-.742.74-.742h2.964c.407 0 .74.334.74.741 0 .408-.333.74-.74.74zm-5.926 0a.743.743 0 01-.741-.74c0-.408.333-.742.74-.742.408 0 .741.334.741.741 0 .408-.333.74-.74.74zm7.407-9.63h-.74v-.74a.743.743 0 00-.741-.741.743.743 0 00-.741.74v.741H7.776v-.74a.743.743 0 00-.74-.741.743.743 0 00-.741.74v.741h-.74a2.225 2.225 0 00-2.223 2.222v8.89c0 1.225.997 2.222 2.222 2.222h8.89a2.225 2.225 0 002.221-2.223V6.296a2.225 2.225 0 00-2.222-2.223z"
                    fill="#fff"
                />
            </mask>
            <g mask="url(#a-SIC)">
                <path fill="#1E2038" d="M0 0H20V20H0z" />
            </g>
        </svg>
    );

};

export const PythonIcon = () => {
    return (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.958.69C4.24.69 4.472 2.301 4.472 2.301l.004 1.67h3.549v.502H3.067s-2.38-.27-2.38 3.482c0 3.752 2.077 3.619 2.077 3.619h1.24V9.834s-.067-2.077 2.043-2.077h3.52s1.977.032 1.977-1.91V2.633s.3-1.945-3.586-1.945zM6.002 1.812a.638.638 0 11.001 1.275.638.638 0 01-.001-1.275z"
                fill="url(#paint0_linear_1)"
            />
            <path
                d="M8.064 15.261c3.718 0 3.486-1.612 3.486-1.612l-.004-1.671H7.997v-.502h4.958s2.38.27 2.38-3.482c0-3.751-2.077-3.618-2.077-3.618h-1.24v1.74s.067 2.077-2.043 2.077h-3.52s-1.977-.032-1.977 1.911v3.213s-.3 1.944 3.586 1.944zm1.956-1.123a.638.638 0 11-.001-1.276.638.638 0 01.001 1.276z"
                fill="url(#paint1_linear_1)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_1"
                    x1={2.09513}
                    y1={1.96309}
                    x2={9.33779}
                    y2={9.22997}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#387EB8" />
                    <stop offset={1} stopColor="#366994" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_1"
                    x1={6.55027}
                    y1={6.58661}
                    x2={14.3289}
                    y2={14.0389}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FFE052" />
                    <stop offset={1} stopColor="#FFC331" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export const SparkIcon = () => {
    return (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.774 11.955c-.032-.068-.047-.103-.065-.136-.474-.885-.947-1.77-1.425-2.655-.049-.088-.042-.14.023-.217.755-.865 1.5-1.734 2.255-2.595a.227.227 0 00.06-.117l-.66.169c-.91.237-1.827.472-2.729.713-.084.022-.123-.002-.165-.071a272.78 272.78 0 00-1.56-2.535.345.345 0 00-.113-.124l-.126.677c-.145.798-.29 1.59-.433 2.392-.016.086-.038.172-.045.258-.007.082-.05.113-.127.136-1.073.332-2.145.665-3.217.999a.36.36 0 00-.144.078L5.948 9.96c-.033.025-.054.045-.078.06-.548.348-1.098.696-1.645 1.045-.066.042-.118.048-.191.015-.656-.289-1.316-.574-1.974-.86-.295-.13-.56-.3-.766-.55-.466-.559-.374-1.195.248-1.59.203-.128.435-.222.665-.296 1.052-.336 2.108-.66 3.156-.986.089-.027.13-.066.146-.16.142-.798.287-1.602.434-2.391.079-.427.12-.864.332-1.256.08-.15.177-.297.294-.423.42-.457 1.003-.474 1.45-.04.15.148.278.32.39.498.487.781.967 1.567 1.45 2.356.056.093.107.111.211.084 1.176-.31 2.352-.614 3.534-.92.244-.062.489-.085.739-.04.542.1.78.505.595 1.02-.083.235-.227.432-.39.62-.82.948-1.645 1.901-2.46 2.846-.068.077-.07.133-.023.22.492.91.98 1.817 1.475 2.738.117.218.207.445.21.695.005.57-.42 1.036-.996 1.12-.323.045-.623-.022-.926-.114-.738-.223-1.475-.444-2.218-.662-.069-.02-.095-.047-.107-.12-.085-.51-.178-1.02-.268-1.53-.003-.014.002-.029.004-.06.842.228 1.682.453 2.547.689"
                fill="#E25A1C"
            />
        </svg>
    );
};

export const PipelineIcon = () => {
    return (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M6.332 2h3.333v3.333H6.332V2z" fill="#91CBD7" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.332 5h.667v3.333h4.666v-3h.667v3h4.667V5h.666v4H8.332v2h-.667V9H2.332V5z"
                fill="#D79191"
            />
            <path
                d="M15.001 3.667a1.667 1.667 0 11-3.333 0 1.667 1.667 0 013.333 0z"
                fill="#FADBBA"
            />
            <path
                d="M9.665 12.333a1.667 1.667 0 11-3.333 0 1.667 1.667 0 013.333 0z"
                fill="#91CBD7"
            />
            <path d="M4.333 5.333H1L2.667 2l1.666 3.333z" fill="#FFD086" />
        </svg>
    );
};

export const StreamingIcon = () => {
    return (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.999 2a6 6 0 110 12 6 6 0 010-12zm7.333 6A7.333 7.333 0 10.665 8a7.333 7.333 0 0014.667 0z"
                fill="#3772A3"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.558 9.164a.686.686 0 00.01.008v.001l-.002-.002-.003-.003-.003-.002-.001-.001v-.001h-.001zm-1.122.008a.794.794 0 01.122-.073c.1-.049.25-.1.443-.1a1.013 1.013 0 01.55.162l.016.011a.667.667 0 00.878-1.003l-.444.497.444-.498h-.001l-.002-.002-.004-.004-.01-.009a1.262 1.262 0 00-.113-.086 2.346 2.346 0 00-1.313-.401 2.346 2.346 0 00-1.314.401 1.66 1.66 0 00-.113.086l-.01.01-.004.003-.002.001-.001.001.443.498-.444-.497a.667.667 0 00.878 1.003zM9.665 6.666l.315-.588a.667.667 0 01-.624 1.179l-.007-.004a2.432 2.432 0 00-.311-.114A3.729 3.729 0 007.997 7a3.73 3.73 0 00-1.038.14 2.437 2.437 0 00-.312.114l-.007.004a.667.667 0 01-.624-1.179l.315.588-.315-.588h.002l.002-.002.004-.002.012-.006a1.708 1.708 0 01.15-.069c.097-.04.23-.09.4-.14a5.06 5.06 0 011.412-.193 5.06 5.06 0 011.411.193 3.76 3.76 0 01.55.209l.012.006.005.003h.002v.001l-.314.588zM10.333 4.667l.396-.537a.667.667 0 01-.787 1.077H9.94a3.14 3.14 0 00-.495-.255 3.93 3.93 0 00-1.48-.285c-.63 0-1.115.143-1.438.28a2.69 2.69 0 00-.45.245.667.667 0 01-.827-1.046l.4.502-.4-.502.002-.001.002-.002.005-.004.015-.012c.012-.008.026-.02.045-.032.036-.026.086-.06.15-.1a4.02 4.02 0 01.536-.274 4.994 4.994 0 011.96-.387c.833 0 1.51.19 1.983.383a4.468 4.468 0 01.71.365l.045.031.015.01.006.005.002.001.001.001-.395.537z"
                fill="#91CBD7"
            />
            <path
                d="M11.57 15.332H4.431a.333.333 0 01-.245-.56l3.57-3.843a.333.333 0 01.488 0l3.569 3.843a.333.333 0 01-.245.56z"
                fill="#3772A3"
            />
        </svg>
    );
};

export const SwitchIcon = () => {
    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"

        >
            <path
                d="M18 13.5l3 3-3 3M3 16.5h18M6 10.5l-3-3 3-3M21 7.5H3"
                stroke="#9495A0"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};


export const ClockIcon = () => {
    return (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="a-cici"
                style={{
                    maskType: 'alpha'
                }}
                maskUnits="userSpaceOnUse"
                x={1}
                y={1}
                width={14}
                height={14}
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 1.334a6.674 6.674 0 00-6.666 6.667 6.674 6.674 0 006.667 6.666 6.674 6.674 0 006.666-6.666 6.674 6.674 0 00-6.666-6.667zM8 13.21A5.215 5.215 0 012.792 8a5.215 5.215 0 015.21-5.209 5.215 5.215 0 015.21 5.21A5.215 5.215 0 018 13.21zM8.5 5.21v2.677l1.998 1.857a.515.515 0 010 .766.614.614 0 01-.824 0L7.505 8.493a.517.517 0 01-.168-.409l-.002-.011-.001-.014V5.21c0-.3.26-.542.582-.542.322 0 .583.243.583.542z"
                    fill="#fff"
                />
            </mask>
            <g mask="url(#a-cici)">
                <path fill="#9B9FC6" d="M0 0H16V16H0z" />
            </g>
        </svg>
    );
};


export const GlobeIcon = ({ active }: { active: boolean }) => {
    const color = active ? "#FCAD01" : "#fff"
    return (
        <svg
            width={20}
            height={20}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                opacity={0.2}
                d="M10 17.5a7.5 7.5 0 100-15 7.5 7.5 0 000 15z"
                fill={color}
            />
            <path
                d="M10 17.5a7.5 7.5 0 100-15 7.5 7.5 0 000 15z"
                stroke={color}
                strokeMiterlimit={10}
            />
            <path
                d="M2.928 7.5h14.145M2.928 12.5h14.145"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10 17.299c1.726 0 3.125-3.268 3.125-7.299 0-4.03-1.4-7.299-3.125-7.299-1.726 0-3.125 3.268-3.125 7.3 0 4.03 1.4 7.298 3.125 7.298z"
                stroke={color}
                strokeMiterlimit={10}
            />
        </svg>
    )
}

export const LeftArrowIcon = () => {
    return (
        <svg
            width={6}
            height={10}
            viewBox="0 0 6 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.258.5L.188 1.558 3.663 5 .187 8.443 1.258 9.5 5.814 5 1.258.5z"
                fill="#fff"
            />
        </svg>
    );
};

export const DataBricksIcon = () => {
    return (
        <svg
            width={48}
            height={48}
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width={48} height={48} rx={4} fill="#fff" fillOpacity={0.9} />
            <path
                d="M14.054 34.63v-2.245c0-.059-.037-.095-.096-.095h-.736v-.877h.736c.06 0 .096-.036.096-.095v-1.406h1.045v1.406c0 .059.037.095.096.095h1.03v.877h-1.03c-.059 0-.096.036-.096.095v1.988c0 .935.332 1.016.759 1.016.154 0 .39-.022.522-.037v.913c-.176.022-.463.059-.795.059-.405-.022-1.531-.022-1.531-1.693zm28.454.545l.854-.449c.191.45.56.744.986.744.332 0 .7-.14.7-.545 0-.272-.177-.427-.582-.567l-.581-.191c-.817-.25-1.222-.722-1.222-1.384 0-.84.699-1.465 1.649-1.465.758 0 1.398.412 1.708 1.053l-.854.47c-.192-.412-.501-.64-.87-.64-.367 0-.617.192-.617.486 0 .25.19.45.581.567l.582.191c.854.273 1.259.744 1.259 1.385 0 1.015-.87 1.538-1.745 1.538-.876-.022-1.576-.471-1.848-1.193zm-3.217-.876c-.022.023-.037.037-.037.06v1.87h-1.067v-6.921h1.067v3.784c0 .037.022.081.059.081.037.022.08 0 .096-.022l1.722-1.752h1.296l-2.01 2.039c-.037.037-.037.081 0 .118l2.187 2.672h-1.296l-1.686-2.105c-.022-.022-.037-.037-.059-.037s-.037 0-.059.022l-.213.191zm-1.627-2.245l-.678.64c-.39-.294-.772-.427-1.2-.427-.89 0-1.553.663-1.553 1.561 0 .898.663 1.561 1.553 1.561.39 0 .796-.14 1.223-.427l.603.64c-.868.641-1.34.759-1.936.759-.714 0-1.355-.25-1.818-.722-.45-.449-.7-1.111-.7-1.81 0-1.466 1.068-2.533 2.54-2.533.471 0 1.193.073 1.966.758zm-4.999-2.083a.64.64 0 01-.64.64.65.65 0 01-.641-.64.641.641 0 011.281 0zm-.103 6.257h-1.067v-4.815h1.067v4.815zm-3.386-2.105v2.127h-1.068v-4.814h1.045v.581c0 .037.023.081.06.096.036.022.08 0 .095-.037.272-.449.773-.744 1.318-.744.08 0 .132 0 .176.023v1.09c-.058-.023-.154-.023-.25-.023-.854-.015-1.377.648-1.377 1.7zm-5.72-.295c0-.876.662-1.56 1.508-1.56.854 0 1.51.684 1.51 1.56s-.663 1.561-1.51 1.561c-.846 0-1.509-.685-1.509-1.56zm.095 1.833h.037c.022 0 .059.022.08.037.369.427.914.663 1.532.663 1.318 0 2.326-1.112 2.326-2.533 0-.7-.235-1.325-.677-1.81a2.228 2.228 0 00-1.664-.722c-.603 0-1.163.25-1.531.7a.09.09 0 01-.096.021c-.037-.022-.059-.037-.059-.08v-2.614h-1.067v6.92h1.067v-.486c-.007-.059.015-.074.052-.096zm-4.417-.272c-.832 0-1.51-.685-1.51-1.56 0-.877.663-1.562 1.51-1.562.854 0 1.509.685 1.509 1.561 0 .876-.677 1.561-1.51 1.561zm2.503.84v-4.816H20.59v.486c0 .037-.022.081-.059.081-.036.022-.08 0-.095-.022-.346-.427-.891-.662-1.532-.662-1.317 0-2.326 1.111-2.326 2.532s1.03 2.533 2.326 2.533c.604 0 1.164-.25 1.532-.7.022-.037.059-.037.095-.022.037.022.06.037.06.081v.53h1.045v-.022zm-11.478-.84c-.831 0-1.509-.685-1.509-1.56 0-.877.663-1.562 1.51-1.562.831 0 1.509.685 1.509 1.561 0 .876-.678 1.561-1.51 1.561zm2.504.84v-4.816h-1.046v.486c0 .037-.022.081-.059.081-.037.022-.08 0-.095-.022-.346-.427-.891-.662-1.532-.662-1.318 0-2.326 1.111-2.326 2.532s1.03 2.533 2.326 2.533c.604 0 1.164-.25 1.532-.7.022-.037.059-.037.095-.022.037.022.06.037.06.081v.53h1.045v-.022zm-8.165-.84c-.854 0-1.509-.685-1.509-1.56 0-.877.663-1.562 1.51-1.562.831 0 1.508.685 1.508 1.561.008.876-.677 1.561-1.509 1.561zm2.503.84v-6.906H5.934v2.591c0 .037-.022.081-.06.081-.036.022-.08 0-.095-.022-.368-.427-.913-.663-1.531-.663-1.318 0-2.327 1.112-2.327 2.533 0 .7.236 1.325.678 1.811.427.471 1.03.721 1.664.721.603 0 1.163-.25 1.53-.699a.09.09 0 01.097-.022c.036.022.058.037.058.081v.508h1.046v-.015H7z"
                fill="#000"
            />
            <path
                d="M29.367 17.367l-5.78 3.276-6.14-3.49-.286.155v2.532l6.434 3.667 5.78-3.276v1.347l-5.78 3.276-6.147-3.49-.287.155v.427l6.434 3.666 6.457-3.666v-2.533l-.288-.154-6.176 3.49-5.757-3.277v-1.325l5.757 3.254 6.456-3.666v-2.496l-.331-.176-6.125 3.467-5.448-3.1 5.448-3.077 4.498 2.533.405-.214v-.309l-4.903-2.768-6.435 3.652v.39l6.435 3.666 5.779-3.276v1.34z"
                fill="#FF3621"
            />
        </svg>
    );
};

export const ClouderaIcon = () => {
    return (
        <svg
            width={48}
            height={48}
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width={48} height={48} rx={4} fill="#fff" fillOpacity={0.9} />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.831 24.306c0 .818-.47 1.31-1.126 1.31-.655 0-1.126-.492-1.126-1.31v-2.878h-1.193v2.834c0 1.487.935 2.43 2.32 2.43 1.383 0 2.318-.943 2.318-2.43v-2.834h-1.193v2.878zm22.256.265l-.714-1.803-.715 1.803h1.429zm2.002 2.003h-1.207l-.42-1.053h-2.186l-.42 1.053h-1.207l2.171-5.146h1.068l2.201 5.146zm-7.067-3.365c0-.228-.089-.441-.229-.56-.154-.139-.382-.205-.692-.205h-1.14v1.546h1.14c.31 0 .523-.066.678-.199a.77.77 0 00.243-.582zm-.118 1.635l1.465 1.73h-1.384l-1.37-1.627h-.655v1.627h-1.17v-5.146h2.378c.662 0 1.148.162 1.494.456.346.295.552.759.552 1.303 0 .685-.294 1.392-1.31 1.657zm-29.97-3.416H7.74v5.146h3.607v-1.046H8.933v-4.1zM4.67 25.609c-.884 0-1.517-.692-1.517-1.605 0-.912.64-1.604 1.517-1.604.42 0 .773.154 1.082.441l.766-.765c-.464-.479-1.112-.759-1.863-.759-1.546 0-2.746 1.178-2.746 2.688 0 1.509 1.193 2.687 2.746 2.687.78 0 1.465-.317 1.936-.847l-.765-.758c-.302.338-.67.522-1.156.522zm23.492-1.605c0-.927-.67-1.546-1.671-1.546h-.788v3.093h.788c.993 0 1.67-.619 1.67-1.546zm1.237 0c0 1.54-1.134 2.57-2.827 2.57H24.51v-5.146h2.01c1.693 0 2.879 1.038 2.879 2.576zm-13.414.008c0-.935-.618-1.62-1.48-1.62-.868 0-1.48.678-1.48 1.62 0 .942.612 1.605 1.48 1.605.862 0 1.48-.678 1.48-1.605zm1.237 0c0 1.502-1.141 2.68-2.717 2.68-1.575 0-2.716-1.178-2.716-2.68 0-1.502 1.14-2.702 2.716-2.702 1.576 0 2.717 1.193 2.717 2.702zm12.714 2.562h4.454v-1.06h-3.755a3.096 3.096 0 01-.699 1.06zm3.828-2.062V23.46h-2.87c.021.176.043.36.043.552 0 .17-.014.331-.03.5h2.857zm-3.88-3.084h4.491v1.06H30.63a3.677 3.677 0 00-.744-1.06z"
                fill="#F96702"
            />
        </svg>
    )
}

export const IpIcon = () => {
    return (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.998 15.2s5.539-3.877 5.539-8.861a5.538 5.538 0 10-11.077 0c0 4.984 5.538 8.861 5.538 8.861zM5.762 4.944v4.342h.794V4.944h-.794zm2.256 0v4.342h.794v-1.68h.812c.356 0 .647-.06.875-.18A1.21 1.21 0 0011 6.94c.108-.202.162-.423.162-.663 0-.253-.056-.48-.168-.683a1.164 1.164 0 00-.508-.477c-.228-.116-.515-.174-.863-.174H8.018zM9.575 6.96h-.763V5.59h.763c.277 0 .475.061.595.185.124.12.186.288.186.503 0 .21-.062.378-.186.502-.12.12-.318.18-.595.18z"
                fill="#C7C7CD"
            />
        </svg>
    );
};

export const WebIcon = () => {
    return (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8 14A6 6 0 108 2a6 6 0 000 12z"
                stroke="#C7C7CD"
                strokeWidth={1.5}
                strokeMiterlimit={10}
            />
            <path
                d="M2 8h12"
                stroke="#C7C7CD"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8 13.839c1.38 0 2.5-2.614 2.5-5.84 0-3.224-1.12-5.838-2.5-5.838S5.5 4.775 5.5 8c0 3.225 1.12 5.839 2.5 5.839z"
                stroke="#C7C7CD"
                strokeWidth={1.5}
                strokeMiterlimit={10}
            />
        </svg>
    )
};

export const ArrowHeadUp = () => {
    return (
        <svg
            width={16}
            height={16}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <mask id="unique-mask-arrow-head-up" fill="white">
                    <path d="M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M11.2838457,12.253025 L4.42657735,17.7704163 C3.93513979,18.1669645 3.8562812,18.8857795 4.25285989,19.3771793 C4.64943857,19.8697219 5.36830887,19.9474316 5.85974644,19.5508834 L11.9878586,14.6208864 L18.1262566,19.7348727 C18.3399748,19.9131479 18.5994082,20 18.8565557,20 C19.1845617,20 19.5091391,19.8605796 19.7354289,19.5885955 C20.1388649,19.1040525 20.0737208,18.3840946 19.5891405,17.9795469 L12.7318722,12.2655957 C12.3135788,11.9159019 11.7078535,11.9113308 11.2838457,12.253025 Z M11.2831998,4.25243561 L4.42608824,9.76943279 C3.93466191,10.1659527 3.85694798,10.8847164 4.25237475,11.3772238 C4.64894437,11.8685885 5.36779823,11.9462927 5.85922457,11.5509155 L11.9871966,6.62012785 L18.1254544,11.7348916 C18.3391677,11.9120114 18.5985951,12 18.8568796,12 C19.1837353,12 19.5083052,11.8594468 19.7345899,11.5886249 C20.1391595,11.1029737 20.0740169,10.3830673 19.5883048,9.97969117 L12.7311932,4.26614811 C12.3129094,3.91533657 11.7071979,3.91190844 11.2831998,4.25243561 Z" />
                </mask>
                <use fill="#6D707E" xlinkHref="#unique-mask-arrow-head-up" />
                <g mask="url(#unique-mask-arrow-head-up)" fill="#D4D6E0">
                    <rect x={0} y={0} width={24} height={24} />
                </g>
            </g>
        </svg>
    );
};
export const ArrowUp = () => {
    return (
        <svg
            width={16}
            height={16}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g
                stroke="none"
                strokeWidth={1}
                fill="none"
                fillRule="evenodd"
            >
                <mask id="unique-mask-arrow-up" fill="white">
                    <path
                        d="M12,3.01980663e-14 C18.627417,3.01980663e-14 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 -8.8817842e-16,18.627417 -8.8817842e-16,12 C-8.8817842e-16,5.372583 5.372583,3.01980663e-14 12,3.01980663e-14 Z M12.7320053,8.26559572 C12.313727,7.91590191 11.7068804,7.91133075 11.2840307,8.25302503 L11.2840307,8.25302503 L4.42700795,13.7704163 C3.93444515,14.1669645 3.85673222,14.8857795 4.25215387,15.3771793 C4.64871835,15.8697219 5.36870574,15.9474316 5.85898287,15.5508834 L5.85898287,15.5508834 L11.9868755,10.6197436 L18.1250537,15.7348727 C18.3387643,15.9131479 18.5981883,16 18.8564695,16 C19.1844638,16 19.5090295,15.8594368 19.7353113,15.5885955 C20.1387328,15.1040525 20.073591,14.3829518 19.5890281,13.9795469 L19.5890281,13.9795469 Z"

                    />
                </mask>
                <use
                    fill="#6D707E"
                    xlinkHref="#unique-mask-arrow-up"
                />
                <g
                    mask="url(#unique-mask-arrow-up)"
                    fill="#D4D6E0"
                >
                    <rect x={0} y={0} width={24} height={24} />
                </g>
            </g>
        </svg>
    );
};

export const ArrowMinimise = () => {
    return (
        <svg
            width={16}
            height={16}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g
                stroke="none"
                strokeWidth={1}
                fill="none"
                fillRule="evenodd"
            >
                <mask id="unique-mask-minimise" fill="white">
                    <path
                        d="M12,24 C18.627417,24 24,18.627417 24,12 C24,5.372583 18.627417,3.01980663e-14 12,3.01980663e-14 C5.372583,3.01980663e-14 0,5.372583 0,12 C0,18.627417 5.372583,24 12,24 Z M5,11 L19,11 C19.5522847,11 20,11.4477153 20,12 L20,12.5 C20,13.0522847 19.5522847,13.5 19,13.5 L5,13.5 C4.44771525,13.5 4,13.0522847 4,12.5 L4,12 C4,11.4477153 4.44771525,11 5,11 Z"
                    />
                </mask>
                <use
                    fill="#6D707E"
                    xlinkHref="#unique-mask-minimise"
                />
                <g
                    mask="url(#unique-mask-minimise)"
                    fill="#D4D6E0"
                >
                    <rect x={0} y={0} width={24} height={24} />
                </g>
            </g>
        </svg>
    );
};

export const Save = () => {
    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g
                stroke="none"
                strokeWidth={1}
                fill="none"
                fillRule="evenodd"
            >
                <mask id="unique-mask-save" fill="white">
                    <path
                        d="M6.5,15 L6.5,18 L17.5,18 L17.5,15 L19.5,15 L19.5,19 C19.5,19.553 19.053,20 18.5,20 L18.5,20 L5.5,20 C4.948,20 4.5,19.553 4.5,19 L4.5,19 L4.5,15 L6.5,15 Z M13,4 C13.276,4 13.5,4.224 13.5,4.5 L13.5,4.5 L13.5,11 L15.5,11 C15.696,11 15.874,11.114 15.955,11.293 C16.036,11.472 16.006,11.682 15.876,11.829 L15.876,11.829 L12.376,15.829 C12.281,15.937 12.144,16 12,16 C11.856,16 11.719,15.938 11.624,15.829 L11.624,15.829 L8.124,11.829 C7.995,11.681 7.963,11.472 8.045,11.293 C8.126,11.115 8.304,11 8.5,11 L8.5,11 L10.5,11 L10.5,4.5 C10.5,4.224 10.724,4 11,4 L11,4 Z" />
                </mask>
                <use
                    fill="#6D707E"
                    xlinkHref="#unique-mask-save"
                />
                <g
                    mask="url(#unique-mask-save)"
                    fill="#D4D6E0"
                >
                    <rect x={0} y={0} width={24} height={24} />
                </g>
            </g>
        </svg>
    );
};


export const Popout = () => {
    return (
        <svg
            width={20}
            height={20}
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20.25 9.875V4.25H14.625"
                stroke="#C7C7CD"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.5 11L20.25 4.25"
                stroke="#C7C7CD"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.25 14V20C17.25 20.1989 17.171 20.3897 17.0303 20.5303C16.8897 20.671 16.6989 20.75 16.5 20.75H4.5C4.30109 20.75 4.11032 20.671 3.96967 20.5303C3.82902 20.3897 3.75 20.1989 3.75 20V8C3.75 7.80109 3.82902 7.61032 3.96967 7.46967C4.11032 7.32902 4.30109 7.25 4.5 7.25H10.5"
                stroke="#C7C7CD"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const FitToView = () => {
    return (
        <svg
            width={32}
            height={32}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"

        >
            <defs>
                <path
                    d="M19.2,4 C19.6418278,4 20,4.3581722 20,4.8 L20,19.2 C20,19.6418278 19.6418278,20 19.2,20 L4.8,20 C4.3581722,20 4,19.6418278 4,19.2 L4,4.8 C4,4.3581722 4.3581722,4 4.8,4 L19.2,4 Z M19.2,4.8 L4.8,4.8 L4.8,19.2 L19.2,19.2 L19.2,4.8 Z M16.7095172,12.8315586 C17.0970483,12.8315586 17.410869,13.1264 17.410869,13.4900966 C17.410869,13.8529103 17.0970483,14.1473103 16.7095172,14.1486345 L16.7095172,14.1486345 L15.2816552,14.1486345 L17.9246345,16.7916138 C18.1806345,17.0484966 18.1806345,17.4651586 17.9246345,17.7220414 C17.6673103,17.9793655 17.2510897,17.9793655 16.9942069,17.7220414 L16.9942069,17.7220414 L14.3379862,15.0649379 L14.3379862,16.5003034 C14.3379862,16.8816552 14.0422621,17.1906207 13.6794483,17.1915034 C13.3157517,17.1915034 13.0217931,16.8816552 13.0217931,16.5003034 L13.0217931,16.5003034 L13.0217931,13.5549793 C13.0217931,13.5421793 13.0248828,13.5289379 13.0248828,13.5170207 C13.0248828,13.5081931 13.0222345,13.4984828 13.0217931,13.4900966 C13.0222345,13.1264 13.3360552,12.8315586 13.7240276,12.8315586 L13.7240276,12.8315586 Z M9.99216552,12.8315586 C10.3805793,12.8315586 10.6939586,13.1264 10.6948414,13.4900966 L10.6948414,13.4900966 L10.690869,13.5161379 C10.690869,13.5280552 10.6944,13.5412966 10.6944,13.5540966 L10.6944,13.5540966 L10.6944,16.4994207 C10.6944,16.8807724 10.4008828,17.1906207 10.0363034,17.1906207 C9.67393103,17.1897379 9.3782069,16.8807724 9.3782069,16.4994207 L9.3782069,16.4994207 L9.3782069,15.0640552 L6.72154483,17.7211586 C6.46510345,17.9784828 6.04888276,17.9784828 5.79111724,17.7211586 C5.53644138,17.4642759 5.53644138,17.0476138 5.79111724,16.790731 L5.79111724,16.790731 L8.43542069,14.1486345 L7.00755862,14.1486345 C6.62046897,14.1473103 6.30444138,13.8529103 6.30444138,13.4900966 C6.30444138,13.1264 6.62046897,12.8315586 7.00755862,12.8315586 L7.00755862,12.8315586 Z M16.9946483,5.9945931 C17.251531,5.73771034 17.6677517,5.73771034 17.9250759,5.9945931 C18.1810759,6.25103448 18.1810759,6.66769655 17.9250759,6.92546207 L17.9250759,6.92546207 L15.2816552,9.568 L16.7095172,9.568 C17.0970483,9.56888276 17.410869,9.8624 17.410869,10.2252138 C17.410869,10.5889103 17.0970483,10.8833103 16.7095172,10.8833103 L16.7095172,10.8833103 L13.7240276,10.8833103 C13.3360552,10.8833103 13.0222345,10.5889103 13.0217931,10.2252138 C13.0222345,10.2150621 13.0248828,10.208 13.0253241,10.1991724 C13.0253241,10.185931 13.0222345,10.1740138 13.0222345,10.1607724 L13.0222345,10.1607724 L13.0222345,7.21633103 C13.0222345,6.83365517 13.3161931,6.52424828 13.6798897,6.52424828 C14.0427034,6.52424828 14.3384276,6.83365517 14.3384276,7.21633103 L14.3384276,7.21633103 L14.3384276,8.65169655 Z M5.79155862,5.99415172 C6.04932414,5.73726897 6.46554483,5.73726897 6.72198621,5.99415172 L6.72198621,5.99415172 L9.37864828,8.65125517 L9.37864828,7.21633103 C9.37864828,6.83365517 9.67437241,6.52424828 10.0367448,6.52424828 C10.4013241,6.52424828 10.6948414,6.83365517 10.6948414,7.21633103 L10.6948414,7.21633103 L10.6948414,10.160331 C10.6948414,10.1735724 10.6913103,10.1854897 10.6913103,10.198731 C10.6913103,10.208 10.6939586,10.2150621 10.6948414,10.2252138 C10.6939586,10.5889103 10.3805793,10.8833103 9.99216552,10.8833103 L9.99216552,10.8833103 L7.008,10.8833103 C6.62091034,10.8833103 6.30488276,10.5889103 6.30488276,10.2252138 C6.30488276,9.8624 6.62091034,9.56888276 7.00755862,9.56755862 L7.00755862,9.56755862 L8.43586207,9.56755862 L5.79155862,6.92502069 C5.53688276,6.66725517 5.53688276,6.2505931 5.79155862,5.99415172 Z"
                    id="fit-to-view"
                />
            </defs>
            <g
                stroke="none"
                strokeWidth={1}
                fill="none"
                fillRule="evenodd"
            >
                <mask id="mask-fit-to-view" fill="#2A2C42">
                    <use xlinkHref="#fit-to-view" />
                </mask>
                <use
                    fill="#9495A0"
                    fillRule="nonzero"
                    xlinkHref="#fit-to-view"
                />
                <g
                    mask="url(#mask-fit-to-view)"
                    fill="#000000"
                >
                    <rect x={0} y={0} width={24} height={24} />
                </g>
            </g>
        </svg>
    );
};

export const ZoomInView = () => {
    return (
        <svg
            width={19}
            height={19}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <defs>
                <polygon
                    id="zoom-in-view"
                    points="13.0081301 20 13.0081301 13.0223124 20 13.0223124 20 10.9776876 13.0081301 10.9776876 13.0081301 4 10.9918699 4 10.9918699 10.9776876 4 10.9776876 4 13.0223124 10.9918699 13.0223124 10.9918699 20"
                />
            </defs>
            <g
                stroke="none"
                strokeWidth={1}
                fill="none"
                fillRule="evenodd"
            >
                <mask id="mask-zoom-in-view" fill="#2A2C42">
                    <use xlinkHref="#zoom-in-view" />
                </mask>
                <use id="+" fill="#9495A0" xlinkHref="#zoom-in-view" />
                <g
                    mask="url(#mask-zoom-in-view)"
                    fill="#000000"
                >
                    <rect x={0} y={0} width={24} height={24} />
                </g>
            </g>
        </svg>
    );
};

export const ZoomInViewBlack = () => {
    return (
        <svg
            width={19}
            height={19}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <defs>
                <polygon
                    id="zoom-in-view"
                    points="13.0081301 20 13.0081301 13.0223124 20 13.0223124 20 10.9776876 13.0081301 10.9776876 13.0081301 4 10.9918699 4 10.9918699 10.9776876 4 10.9776876 4 13.0223124 10.9918699 13.0223124 10.9918699 20"
                />
            </defs>
            <g
                stroke="none"
                strokeWidth={1}
                fill="none"
                fillRule="evenodd"
            >
                <mask id="mask-zoom-in-view" fill="#2A2C42">
                    <use xlinkHref="#zoom-in-view" />
                </mask>
                <use id="+" fill="#000000" xlinkHref="#zoom-in-view" />
                <g
                    mask="url(#mask-zoom-in-view)"
                    fill="black"
                >
                    <rect x={0} y={0} width={24} height={24} />
                </g>
            </g>
        </svg>
    );
};

export const ZoomOutView = () => {
    return (
        <svg
            width={19}
            height={19}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <defs>
                <polygon id="zoom-out-view" points="20 13 20 11 4 11 4 13" />
            </defs>
            <g
                stroke="none"
                strokeWidth={1}
                fill="none"
                fillRule="evenodd"
            >
                <mask id="mask-zoom-out-view" fill="#2A2C42">
                    <use xlinkHref="#zoom-out-view" />
                </mask>
                <use id="-" fill="#9495A0" xlinkHref="#zoom-out-view" />
                <g
                    mask="url(#mask-zoom-out-view)"
                    fill="#000000"
                >
                    <rect x={0} y={0} width={24} height={24} />
                </g>
            </g>
        </svg>
    );
};

export const Preview = () => {
    return (
        <svg
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <defs>
                <path
                    d="M12,6 C15.6965761,6 18.8328251,8.50026604 20,11.9844311 C18.8328251,15.4685651 15.6965761,17.9688312 12,17.9688312 C8.30342388,17.9688312 5.16717486,15.4685961 4,11.9844311 C5.16717486,8.50026604 8.30342388,6 12,6 Z M12,7.99482067 C9.79084328,7.99482067 8,9.78101241 8,11.9844311 C8,14.1878188 9.79084328,15.9740415 12,15.9740415 C14.2091567,15.9740415 16,14.1877878 16,11.9844311 C16,9.78101241 14.2091567,7.99482067 12,7.99482067 Z M13.4142091,10.5738952 C14.1952533,11.3529107 14.1952533,12.6159514 13.4142091,13.3949669 C12.633165,14.1739824 11.366835,14.1739824 10.5857909,13.3949669 C9.80474672,12.6159514 9.80474672,11.3529107 10.5857909,10.5738952 C11.366835,9.79487974 12.633165,9.79487974 13.4142091,10.5738952 Z"
                    id="preview"
                />
            </defs>
            <g
                stroke="none"
                strokeWidth={1}
                fill="none"
                fillRule="evenodd"
            >
                <mask id="mask-preview" fill="white">
                    <use xlinkHref="#preview" />
                </mask>
                <use
                    fill="#000000"
                    fillRule="nonzero"
                    xlinkHref="#preview"
                />
                <g
                    mask="url(#mask-preview)"
                    fill="#D4D6E0"
                >
                    <g transform="translate(-74.000000, -18.000000)">
                        <rect x={0} y={0} width={171} height={60} />
                    </g>
                </g>
            </g>
        </svg>
    );
};


export const AddVariable = () => {
    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <defs>
                <path
                    d="M12.7781902,2.15479166 L18.41135,4.48812283 C18.9096168,4.69451172 19.3054883,5.09038317 19.5118772,5.58865001 L21.8452083,11.2218098 C22.0515972,11.7200766 22.0515972,12.2799234 21.8452083,12.7781902 L19.5118772,18.41135 C19.3054883,18.9096168 18.9096168,19.3054883 18.41135,19.5118772 L12.7781902,21.8452083 C12.2799234,22.0515972 11.7200766,22.0515972 11.2218098,21.8452083 L5.58865001,19.5118772 C5.09038317,19.3054883 4.69451172,18.9096168 4.48812283,18.41135 L2.15479166,12.7781902 C1.94840278,12.2799234 1.94840278,11.7200766 2.15479166,11.2218098 L4.48812283,5.58865001 C4.69451172,5.09038317 5.09038317,4.69451172 5.58865001,4.48812283 L11.2218098,2.15479166 C11.7200766,1.94840278 12.2799234,1.94840278 12.7781902,2.15479166 Z M12,4 L11.9871766,4.00255073 L6.35401687,6.3358819 L6.34314575,6.34314575 L6.3358819,6.35401687 L4.00255073,11.9871766 L4,12 L4.00255073,12.0128234 L6.3358819,17.6459831 L6.34314575,17.6568542 L6.35401687,17.6641181 L11.9871766,19.9974493 L12,20 L12.0128234,19.9974493 L17.6459831,17.6641181 L17.6568542,17.6568542 L17.6641181,17.6459831 L19.9974493,12.0128234 L20,12 L19.9974493,11.9871766 L17.6641181,6.35401687 L17.6568542,6.34314575 L17.6459831,6.3358819 L12.0128234,4.00255073 L12,4 Z M12,8 C12.7333333,8 13.3333333,8.6 13.3333333,9.33333333 L13.3333333,9.33333333 L13.3333333,10.6666667 L14.6666667,10.6666667 C15.4,10.6666667 16,11.2666667 16,12 C16,12.7333333 15.4,13.3333333 14.6666667,13.3333333 L14.6666667,13.3333333 L13.3333333,13.3333333 L13.3333333,14.6666667 C13.3333333,15.4 12.7333333,16 12,16 C11.2666667,16 10.6666667,15.4 10.6666667,14.6666667 L10.6666667,14.6666667 L10.6666667,13.3333333 L9.33333333,13.3333333 C8.6,13.3333333 8,12.7333333 8,12 C8,11.2666667 8.6,10.6666667 9.33333333,10.6666667 L9.33333333,10.6666667 L10.6666667,10.6666667 L10.6666667,9.33333333 C10.6666667,8.6 11.2666667,8 12,8 Z"
                    id="add-variable"
                />
            </defs>
            <g
                stroke="none"
                strokeWidth={1}
                fill="none"
                fillRule="evenodd"
            >
                <mask id="mask-add-variable" fill="white">
                    <use xlinkHref="#add-variable" />
                </mask>
                <use
                    fill="#979797"
                    fillRule="nonzero"
                    xlinkHref="#add-variable"
                />
                <g mask="url(#mask-add-variable)" fill="#D4D6E0">
                    <g >
                        <rect x={0} y={0} width={24} height={24} />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const RunBtn = () => {
    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <defs>
                <path
                    d="M12,4 C7.58886092,4 4,7.58886092 4,12 C4,16.4111391 7.58886092,20 12,20 C16.4111391,20 20,16.4111391 20,12 C20,7.58886092 16.4111391,4 12,4 Z M10,15.9999151 L10,7.99997171 L16,11.9999151 L10,15.9999151 Z"
                    id="run-btn"
                />
            </defs>
            <g
                stroke="none"
                strokeWidth={1}
                fill="none"
                fillRule="evenodd"
            >
                <g>
                    <mask id="mask-run-btn" fill="white">
                        <use xlinkHref="#run-btn" />
                    </mask>
                    <use fill="#000000" fillRule="nonzero" xlinkHref="#run-btn" />
                    <g
                        mask="url(#mask-run-btn)"
                        fill="#14182A"
                    >
                        <g transform="translate(-74.000000, -18.000000)" >
                            <rect x={0} y={0} width={171} height={60} />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const SaveBtn = () => {
    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <defs>
                <path
                    d="M16.7271806,4 C16.9010053,4 17.4859532,4.47864922 18.3016886,5.13303219 C19.117424,5.78741515 20,6.43186231 20,6.62785387 L20,19.3999872 C20,19.7313581 19.7313708,19.9999872 19.4,19.9999872 L4.6,19.9999872 C4.26862915,19.9999872 4,19.7313581 4,19.3999872 L4,4.6 C4,4.26862915 4.26862915,4 4.6,4 L16.7271806,4 L16.7271806,4 Z M11.6,12 C10.1640597,12 9,13.1640597 9,14.6 C9,16.0359403 10.1640597,17.2 11.6,17.2 C13.0359403,17.2 14.2,16.0359403 14.2,14.6 C14.2,13.1640597 13.0359403,12 11.6,12 Z M14.75,5.25 L8.25,5.25 L8.25,9.75 L14.75,9.75 L14.75,5.25 Z"
                    id="save-btn"
                />
            </defs>
            <g
                stroke="none"
                strokeWidth={1}
                fill="none"
                fillRule="evenodd"
            >
                <g>
                    <mask id="mask-save-btn" fill="white">
                        <use xlinkHref="#save-btn" />
                    </mask>
                    <use
                        fill="#000000"
                        opacity={0.319999993}
                        xlinkHref="#save-btn"
                    />
                    <g
                        id="\u21B3-\uD83C\uDFA8Color/Neutral/100"
                        mask="url(#mask-save-btn)"
                        fill="#14182A"
                    >
                        <rect x={0} y={0} width={24} height={24} />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const AddTabBtn = () => {
    return (
        <svg
            width={20}
            height={20}
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <defs>
                <path
                    d="M10,2.5 C10.4602373,2.5 10.8333333,2.87078857 10.8333333,3.3278314 L10.833,9.166 L16.6725,9.16666667 C17.0940385,9.16666667 17.4424408,9.48193294 17.4935469,9.89485966 L17.5,10 C17.5,10.46 17.1291667,10.8333333 16.6725,10.8333333 L16.6725,10.8333333 L10.833,10.833 L10.8333333,16.6721686 C10.8333333,17.0941981 10.518163,17.4424674 10.1051625,17.49355 L10,17.5 C9.53976271,17.5 9.16666667,17.1292114 9.16666667,16.6721686 L9.166,10.833 L3.3275,10.8333333 C2.90596154,10.8333333 2.55755917,10.5187771 2.50645312,10.1053042 L2.5,10 C2.5,9.54 2.87083333,9.16666667 3.3275,9.16666667 L3.3275,9.16666667 L9.166,9.166 L9.16666667,3.3278314 C9.16666667,2.90580187 9.48183695,2.55753265 9.89483751,2.50644998 L10,2.5 Z"
                    id="add-tab-btn"
                />
            </defs>
            <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                <g
                    transform="translate(-509.000000, -67.000000)"
                >
                    <g
                        transform="translate(507.000000, 65.000000)"
                    >
                        <mask id="mask-add-tab-btn" fill="white">
                            <use xlinkHref="#add-tab-btn" />
                        </mask>
                        <use fill="#42526E" fillRule="evenodd" xlinkHref="#add-tab-btn" />
                        <g
                            mask="url(#mask-add-tab-btn)"
                            fill="#E0E1EC"
                            fillRule="evenodd"
                        >
                            <polygon points="0 20 20 20 20 0 0 0" />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const overFlowMenu = () => (
    <div style={{marginTop:'2px'}}>
    <svg
        width="14px"
        height="14px"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >

        <defs>
            <path
                d="M20,2 C21.1045695,2 22,2.8954305 22,4 L22,20 C22,21.1045695 21.1045695,22 20,22 L4,22 C2.8954305,22 2,21.1045695 2,20 L2,4 C2,2.8954305 2.8954305,2 4,2 L20,2 Z M20,3.5 L4,3.5 C3.75454011,3.5 3.55039163,3.67687516 3.50805567,3.91012437 L3.5,4 L3.5,20 C3.5,20.2454599 3.67687516,20.4496084 3.91012437,20.4919443 L4,20.5 L20,20.5 C20.2454599,20.5 20.4496084,20.3231248 20.4919443,20.0898756 L20.5,20 L20.5,4 C20.5,3.75454011 20.3231248,3.55039163 20.0898756,3.50805567 L20,3.5 Z M9.67712551,6 L15.75,12 L9.67712551,18 L8.25,16.59 L12.8856275,12 L8.25,7.41 L9.67712551,6 Z"
                id="overflow-menu-header-path"
            />
        </defs>
        <g
            stroke="none"
            strokeWidth={1}
            fill="none"
            fillRule="evenodd"
        >
            <g>
                <mask id="overflow-menu-header-mask" fill="white">
                    <use xlinkHref="#overflow-menu-header-path" />
                </mask>
                <use fill="#000000" xlinkHref="#overflow-menu-header-path" />
                <g
                    id="\u21B3-\uD83C\uDFA8Color/Neutral/200"
                    mask="url(#overflow-menu-header-mask)"
                    fill="white"
                >
                    <rect x={0} y={0} width={24} height={24} />
                </g>
            </g>
        </g>
    </svg>
    </div>
);